import type { EventLogQuery } from 'common/models';

export const defaultEventLogQuery: EventLogQuery = {
  page: 1,
  pageSize: 50 // also used as default value for getInfiniteNextPageParam
};

export const defaultNotificationQuery: EventLogQuery = {
  page: 1,
  pageSize: 50
};
